export default __webpack_public_path__ + "static/media/infoSymbol.4d7e774d.svg";